<template>
    <div>
        <Table :columns='tableColumns' :data='dataList'></Table>
    </div>
</template>
<script>
    import matterManageApi from "@/api/matterManage";
    export default {
        props: ["operateItem"],
        data() {
            return {
                dataList: [],
                tableColumns: [{ /* 表格 */
                        title: '操作时间',
                        key: 'operationTime',
                        align: "center",
                    }, {
                        title: '操作内容',
                        key: 'operationContent',
                        align: "center",
                    },
                    {
                        title: '账号',
                        key: 'operator',
                        align: "center",
                    },
                ]
            }
        },
        methods: {
            showLogs() {
                matterManageApi.showLogs(this.operateItem.materialId).then(res => {
                    if (res.data.code == '200') {
                        for (let i = 0; i < res.data.data.length; i++) {
                            switch (res.data.data[i].operationContent) { //状态（0-创建、1-发布、2-编辑、3-撤回、4-删除、5-置顶）
                                case 0:
                                    res.data.data[i].operationContent = '创建';
                                    break;
                                case 1:
                                    res.data.data[i].operationContent = '发布';
                                    break;
                                case 2:
                                    res.data.data[i].operationContent = '编辑';
                                    break;
                                case 3:
                                    res.data.data[i].operationContent = '撤回';
                                    break;
                                case 4:
                                    res.data.data[i].operationContent = '删除';
                                    break;
                                case 5:
                                    res.data.data[i].operationContent = '置顶';
                                    break;
                            }
                            res.data.data[i].operationTime = this.$tool.timeChange(res.data.data[i].operationTime)
                        }
                        this.dataList = res.data.data
                    } else {
                        this.$Message.error(res.data.message)
                    }
                })
            }
        },
        mounted() {
            this.showLogs()
        },
    }
</script>
<style scoped>

</style>